// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---Z30hZ","changedRecordsList":"changedRecordsList---pm_7M","changedRecord":"changedRecord---mVLee"};